import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postChangeHostBulk = async ({ payload }) => {
  const { data } = await SigliveServiceV1({ method: 'POST', url: `/schedule/bulk-update`, data: payload });

  return data;
};

export default postChangeHostBulk;
